import { NavigationBar } from '@travelnest/hui';
import { Spacer } from '@travelnest/merlin.spacer';
import * as React from 'react';
import { useStore } from 'react-redux';
import { useParams } from 'react-router-dom';

import { IThunkDispatch } from 'store/middleware';
import { IState } from 'store/reducer';
import { currentUserId } from '../../../entities/auth/session/selectors';

import { PropertySwitcher } from '../../components/property-switcher/PropertySwitcher';
import { CalendarBundle } from './Calendar';
import { useCustomersProperties } from './hooks';

export const calendarPrintingStyles = `
	@media print {
		body {
			color-adjust: exact !important;
			-webkit-print-color-adjust: exact !important;
		}

		#calendar-settings {
			visibility: hidden;
		}

		.calendar-column {
			width: 100%;
			height: 85vh;
		}

		.sidebar {
			visibility: hidden;
		}
	}
`;

const CalendarPage: React.FC = () => {
	const { getState }: { getState: () => IState, dispatch: IThunkDispatch } = useStore();
	const customerId = currentUserId(getState());
	const persisted = getState().views.calendar.persistence;

	const { id: routePropertyId } = useParams();
	const [propertyId, setPropertyId] = React.useState<string | number | undefined>(routePropertyId || persisted?.propertyId || undefined);
	const showPropertySwitcher = routePropertyId === undefined;

	// This hook will not load data when the 2nd argument is false.
	const { properties, loading } = useCustomersProperties(customerId, showPropertySwitcher);

	return (
		<div className="portal-wrapper">
			<NavigationBar title="Calendar" />
			<Spacer spacing={'large'} />
			{showPropertySwitcher && <><PropertySwitcher
				customerId={customerId}
				switchProperty={setPropertyId}
				currentPropertyId={propertyId}
				loading={loading}
				properties={properties}
			/><Spacer /></>}
			<CalendarBundle
				propertyId={propertyId}
				loadingProperties={loading}
				initialMonth={persisted?.currentMonth || undefined}
				multiPropertyMode={showPropertySwitcher}
			/>
		</div>
	);
};

export default CalendarPage;
